import { GrindInspectionStore } from "stores/GrindInspectionStore";
import { BullpenGroup } from "./BullpenGroup";

export class GrindInspection extends BullpenGroup {
  static _store: GrindInspectionStore;
}
